import { Debug } from '~';

const debug = Debug('facebook-pixel');

export default {
  props: {
    pixel: Object,
  },
  computed: {
    trackingScript() {
      return `
        <!-- Facebook Pixel Code -->
        <script>
        !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
        document,'script','https://connect.facebook.net/en_US/fbevents.js');

        fbq('init', '${this.pixel.pixel_id}');
        fbq('track', "PageVie");</script>
        <noscript><img height"1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${this.pixel.pixel_id}&ev=PageView&noscript=1"
        /></noscript>
        <!-- End Facebook Pixel Code -->`;
    },
    pixelFiredTimeText() {
      const time = this.pixel.last_fired_at;
      return time ? this.$t('fn.datetime', { timestamp: time }) : this.$t('pos.pixel.never');
    },
  },
  methods: {
    onClick(event) {
      debug.debug('clicked');
      event.preventDefault();

      // eslint-disable-next-line no-alert
      window.prompt(this.$t('terms.misc.copy-prompt'), this.trackingScript);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/facebook-pixel/FacebookPixel.js